<div class="wrapper">
  <div class="fields-row input-block grid grid-cols-2 gap-x-[20px] gap-y-[10px]">
    <div class="item-input col-span-2">
      <div class="search-section">
        <form [formGroup]="form">
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['searchText']"
            [parentFormGroup]="form"
            [searchComponent]="true"
            controlName="searchText"
            suffixIcon="search"
            />
        </form>
        @if (focusedIn) {
          <div class="bid-items-list">
            <!-- Add option always on top -->
            <div
              (mousedown)="!alreadyExists && addNewBidItem()"
              [class.add-option-disabled]="alreadyExists"
              class="each-item flex justify-start items-center gap-[16px] add-option"
              >
              <div class="left flex justify-start items-center">
                <div class="icon-wrapper">
                  <mat-icon>add</mat-icon>
                </div>
              </div>
              <div class="right flex flex-col justify-center items-start">
                <div class="bid-item-heading text-type-6">
                  Add
                  @if (!alreadyExists && searchText) {
                    "{{ searchText }}"
                  }
                </div>
                @if (alreadyExists) {
                  <div class="description text-type-14 already-exists-note">
                    "{{ searchText }}" already exists — select it from the list below
                  </div>
                } @else {
                  <div class="description text-type-14">Create a new bid item</div>
                }
              </div>
            </div>
            <!-- Pending items introduced by approved CORs not yet combined into a CO -->
            @for (pendingItem of filteredPendingItemsList; track pendingItem) {
              <div
                (mousedown)="selectPendingItem(pendingItem)"
                class="each-item flex justify-start items-center gap-[16px]"
                >
                <div class="left flex justify-start items-center">
                  <div class="icon-wrapper">
                    <mat-icon svgIcon="daily-report-page-menu-bid-item"></mat-icon>
                  </div>
                </div>
                <div class="right flex flex-col justify-center items-start">
                  <div class="bid-item-heading text-type-6">
                    Bid item {{ pendingItem.item_no }}
                    <span class="pending-badge" [matTooltip]="'Pending in requests ' + (pendingItem.request_nos || []).join(', ')" matTooltipPosition="above">New item</span>
                  </div>
                  <div class="description text-type-14">{{ pendingItem.item_description | sentenceCase }}</div>
                </div>
              </div>
            }
            <!-- Then show filtered items -->
            @for (eachBidItem of filteredBidItemsList; track eachBidItem) {
              <div
                (mousedown)="selectBidItem(eachBidItem)"
                class="each-item flex justify-start items-center gap-[16px]"
                >
                <div class="left flex justify-start items-center">
                  <div class="icon-wrapper">
                    <mat-icon svgIcon="daily-report-page-menu-bid-item"></mat-icon>
                  </div>
                </div>
                <div class="right flex flex-col justify-center items-start">
                  <div class="bid-item-heading text-type-6">Bid item {{ eachBidItem.item }}</div>
                  <div class="description text-type-14">{{ eachBidItem.description | sentenceCase }}</div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="form?.controls?.itemNo?.errors?.duplicate ? errorMessageMap.itemNo.duplicate : errorMessages['itemNo']"
      [parentFormGroup]="form"
      class="w-full col-span-2"
      controlName="itemNo"
      label="Item no"
      />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['desc']"
      [parentFormGroup]="form"
      class="w-full col-span-2"
      controlName="desc"
      label="item description"
      />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['basisOfPay']"
      [options]="basisOfPayOptions"
      [parentFormGroup]="form"
      class="w-full col-span-1"
      controlName="basisOfPay"
      label="basis Of Pay"
      placeholder="Select"
      />
    <app-number-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['changeInQuantity']"
      [hint]="form?.controls['quantity']?.value ? 'Existing quantity : ' + form.controls['quantity'].value : ''"
      [isDecimalAllowed]="true"
      [min]="-9999999999"
      [parentFormGroup]="form"
      class="w-full col-span-1"
      controlName="changeInQuantity"
      [label]="form?.controls['quantity']?.value ? 'change In Quantity' : 'Quantity'"
      />
    @if (!form?.controls?.unitPrice?.disabled) {
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['unitPrice']"
        [hint]="unitPriceHint"
        [isDecimalAllowed]="true"
        [parentFormGroup]="form"
        class="w-full col-span-1"
        controlName="unitPrice"
        label="unit Price ($)"
        />
    } @else {
      <app-view-field
        [value]="form?.controls?.unitPrice?.value"
        [required]="true"
        class="w-full col-span-1 locked-field"
        label="unit Price ($)"
        />
    }
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['uom']"
      [parentFormGroup]="form"
      class="w-full col-span-1"
      controlName="uom"
      label="uom"
      />
    <app-view-field
      [value]="(form?.controls['totalAmount']?.value | number:'1.2-2') || '0.00'"
      class="w-full col-span-2 adjust-label mb-[10px]"
      label="total Amount ($)"
      />
    <app-number-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['additionalWorkingDays']"
      [isDecimalAllowed]="true"
      [parentFormGroup]="form"
      class="w-full col-span-2"
      controlName="additionalWorkingDays"
      label="additional Working Days"
      />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['locationOfChange']"
      [parentFormGroup]="form"
      class="w-full col-span-2"
      controlName="locationOfChange"
      label="location"
      />
  </div>
</div>
